import { renderCSS } from "@knyt/weaver";
import { hashString } from "./hashString.js";
const EMPTY_STYLE_HASH = "-noop";
function isEmptyStyleObject(obj) {
    return Object.keys(obj).length === 0;
}
/**
 * Serializes a CSS object into a hash and a CSS declaration block
 */
/*
 * ### Private Remarks
 *
 * This function abstracts the serialization of a CSS object to provide
 * a consistent and more description interface for serializing CSS objects.
 */
export function serializeCSSObject($document, cssObject) {
    if (isEmptyStyleObject(cssObject)) {
        return {
            declarationBlock: "",
            hash: EMPTY_STYLE_HASH,
        };
    }
    const declarationBlock = renderCSS($document, cssObject);
    const hash = hashString(declarationBlock);
    return {
        declarationBlock,
        hash,
    };
}
